import React, { useEffect, useState } from "react";
import ListHeader from "../../../../../components/listing/ListHeader";
import ListFooter from "../../../../../components/listing/ListFooter";
import DynamicTable from "../../../../../components/listing/DynamicTable";
import FiltroDepartamento from "./FiltroDepartamento";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import IconEdit from "../../../../../components/icons/IconEdit";
import IconTrash from "../../../../../components/icons/IconTrash";
import CrearDepartamento from "./CrearDepartamento";
import EditarDepartamento from "./EditarDepartamento";
import EliminarDepartamento from "./EliminarDepartamento";

export default function ListarDepartamento() {
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [depAEditar, setDepAEditar] = useState(null);
  const [depAEliminar, setDepAEliminar] = useState(null);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({ nombre: "", codigo: "" });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = apiRoutes.departamentos.listUrl({
          page: pagina - 1,
          size: porPagina,
          nombre: filtros.nombre.trim() || undefined,
          codigo: filtros.codigo.trim() || undefined,
        });
        const res = await appFetchJson(url);
        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);
        setTotalBackend(res?.totalElements ?? res?.total ?? items.length);
      } catch (e) {
        console.error("Error cargando departamentos:", e);
        setError("Error al cargar los departamentos.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  const columns = [
    {
      header: "Nombre",
      accessor: "nombre",
      type: "text",
      width: "40%",
      cellClass: "font-medium text-gray-800 break-words",
    },
    {
      header: "Código",
      accessor: "codigo",
      type: "text",
      width: "40%",
      cellClass: "text-gray-600",
    },
    {
      header: "Acción",
      type: "action",
      width: "20%",
      render: (row) => (
        <div className="flex justify-center items-center gap-2">
          <button title="Editar" onClick={() => setDepAEditar(row)}>
            <IconEdit />
          </button>
          <button title="Eliminar" onClick={() => setDepAEliminar(row)}>
            <IconTrash />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Departamentos"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => { setFiltros({ nombre: "", codigo: "" }); setPagina(1); }}
        showAdd={true}
        addLabel="Agregar"
        onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => { setPorPagina(size); setPagina(1); }}
      />

      {loading && <div className="mt-2 text-sm text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {mostrarFiltros && (
        <FiltroDepartamento
          initialFilters={filtros}
          onSubmit={(nuevos) => { setFiltros(nuevos); setPagina(1); setMostrarFiltros(false); }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      <DynamicTable size="S" data={data} columns={columns} />

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {mostrarCrear && (
        <CrearDepartamento
          onClose={() => setMostrarCrear(false)}
          onCreated={() => { setPagina(1); setReloadKey(k => k+1); setMostrarCrear(false); }}
        />
      )}

      {depAEditar && (
        <EditarDepartamento
          initial={depAEditar}
          onClose={() => setDepAEditar(null)}
          onSaved={() => { setReloadKey(k => k+1); setDepAEditar(null); }}
        />
      )}

      {depAEliminar && (
        <div className="modal-backdrop" onClick={() => setDepAEliminar(null)}>
          <div className="modal-panel-md" onClick={e => e.stopPropagation()}>
            <EliminarDepartamento
              registro={depAEliminar}
              onClose={() => setDepAEliminar(null)}
              onDeleted={() => { setReloadKey(k => k+1); setDepAEliminar(null); }}
            />
          </div>
        </div>
      )}
    </div>
  );
}